// src/components/store/sections/weekly-banner/Variant4CyberWave.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { WeeklyBannerProps } from "./types";

export default function Variant4CyberWave({ banner, subdomain }: WeeklyBannerProps) {
  const imageUrl = banner?.image
    ? banner.image.startsWith("http") || banner.image.startsWith("data:")
      ? banner.image
      : `http://${subdomain ? `${subdomain}.` : ""}localhost:8000${banner.image.startsWith("/") ? "" : "/"}${banner.image}`
    : "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=900&auto=format&fit=crop&q=80";

  return (
    <section className="max-w-7xl mx-auto px-3 sm:px-6 select-none font-sans">
      <div className="relative w-full rounded-[24px] sm:rounded-[36px] bg-[#070b24] overflow-hidden shadow-2xl border border-indigo-950 flex flex-col md:flex-row items-stretch min-h-[340px] sm:min-h-[380px]">
        {/* বাম পাশের ইমেজ ফ্রেম */}
        <div className="relative w-full md:w-[46%] h-64 sm:h-80 md:h-auto bg-[#e5a8b7] overflow-hidden shrink-0 flex items-center justify-center">
          <div className="absolute top-0 left-0 w-28 sm:w-36 h-28 sm:h-36 rounded-br-full bg-[#8b18ec] z-20 flex flex-col items-center justify-center text-white pl-2 pt-2 shadow-lg">
            <span className="text-[9px] sm:text-[11px] font-black uppercase tracking-wider">UP TO</span>
            <span className="text-xl sm:text-3xl font-black leading-tight drop-shadow-sm">
              {banner?.badge_title?.replace(/[^0-9%]/g, "") || "50%"}
            </span>
            <span className="text-[9px] sm:text-[11px] font-black uppercase tracking-wider">OFF</span>
          </div>

          <div className="relative w-full h-full">
            <Image
              src={imageUrl}
              alt={banner?.title || "Cyber Sale"}
              fill
              unoptimized
              className="object-cover object-center md:object-right-bottom"
            />
          </div>

          <div className="hidden md:block absolute -right-1 top-0 bottom-0 w-16 pointer-events-none z-10">
            <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full">
              <path d="M 0,0 C 70,30 70,70 0,100 L 100,100 L 100,0 Z" fill="#070b24" />
              <path d="M 0,0 C 70,30 70,70 0,100" stroke="#bf38fa" strokeWidth="8" fill="none" />
            </svg>
          </div>
        </div>

        {/* ডান পাশের কনটেন্ট এরিয়া */}
        <div className="relative flex-1 p-6 sm:p-10 md:p-12 flex flex-col justify-between z-10 bg-[#070b24]">
          <div className="space-y-1 text-center md:text-right mt-2 sm:mt-0">
            <span className="text-xs sm:text-sm font-black tracking-[0.25em] text-slate-200 uppercase block">
              SPECIAL OFFER
            </span>

            <h2 className="text-4xl sm:text-6xl lg:text-7xl font-black italic tracking-tight text-[#ffb703] uppercase leading-none drop-shadow-[0_4px_16px_rgba(255,183,3,0.35)]">
              {banner?.title?.includes(" ") ? (
                <>
                  <span className="block">{banner.title.split(" ")[0]}</span>
                  <span className="block">{banner.title.split(" ").slice(1).join(" ")}</span>
                </>
              ) : (
                <>
                  <span className="block">CYBER</span>
                  <span className="block">MONDAY</span>
                </>
              )}
            </h2>

            <p className="text-xs sm:text-base font-black tracking-[0.2em] text-white uppercase pt-1">
              {banner?.subtitle || "BIGGEST SALE EVER"}
            </p>
          </div>

          <div className="pt-6 mt-4 border-t border-indigo-950/80 flex flex-col sm:flex-row items-center justify-between gap-4">
            <Link
              href={banner?.target_url || "/products"}
              className="px-6 py-2.5 rounded-full bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-slate-950 font-black text-xs uppercase tracking-wider inline-flex items-center gap-2 shadow-lg shadow-amber-500/20 active:scale-95 transition-all"
            >
              <span>{banner?.button_text || "Shop Now"}</span>
              <ArrowRight className="w-4 h-4" />
            </Link>

            <div className="flex items-center gap-2.5">
              <span className="w-7 h-7 rounded-full bg-white text-[#070b24] flex items-center justify-center text-xs font-black shadow-sm">
                𝕏
              </span>
              <span className="w-7 h-7 rounded-full bg-white text-[#070b24] flex items-center justify-center text-xs font-black shadow-sm">
                f
              </span>
              <span className="w-7 h-7 rounded-full bg-white text-[#070b24] flex items-center justify-center text-xs font-black shadow-sm">
                📷
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export { Variant4CyberWave };